import './less/productBox.less';

const ProductBox = function(){
    let w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
        
    /*    $('.product').matchHeight({byRow : false});*/
    if (w > 767) {
        $('.mh').matchHeight({byRow: false});
        $('.mh-topMenu').matchHeight({byRow: true});
    
        $('.bigger_match').matchHeight({byRow: false});
    }
}


const productBox = new ProductBox();

export { productBox };


// WEBPACK FOOTER //
// ./components/productBox/productBox.js